<template>
  <v-dialog
    v-model="model"
    transition="dialog-bottom-transition"
    :max-width="maxWidth"
  >
    <v-card>
      <v-toolbar
        color="primary"
        dark
      >Импорт данных</v-toolbar>
      <v-card-text class="mt-5">
        <v-row>
          <v-textarea
            label="Данные для импорта"
            hint="Вставьте сюда скопированные данные из диалога импорта"
            v-model="importString"
            :error="errors.length > 0"
            :error-messages="errors"
          >
            <template v-slot:prepend>
              <v-icon>{{ mdiImport }}</v-icon>
            </template>
          </v-textarea>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          @click="doImport"
        >
          Импортировать
        </v-btn>

        <v-btn
          color="green darken-1"
          text
          @click.native="$emit('close')"
        >
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mdiImport
} from '@mdi/js'

import config from '@/app/config'
import idb from '@/app/idb'
import profile from '@/app/profile'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mdiImport,
      importString: '',
      errors: []
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    maxWidth () {
      return config.maxWidth
    }
  },
  mounted () {
    this.errors = []
  },
  methods: {
    doImport () {
      this.errors = []
      if (!this.importString) {
        this.errors.push('Нет данных для импорта')
      } else {
        let objImport
        try {
          objImport = JSON.parse(this.importString)
        } catch (err) {
          this.errors.push('Некорректные данные для импорта')
        } finally {
          profile.getMaxId().then(maxId => {
            let promises = []
            for (let storeName in objImport) {
              if (typeof objImport[storeName] !== 'undefined') {
                for (let i in objImport[storeName]) {
                  let rec = objImport[storeName][i]
                  if (storeName === idb.PROFILES) {
                    rec.id += maxId
                  } else if (storeName === idb.MEASURES) {
                    rec.profileId += maxId
                    delete rec.id
                  }
                  promises.push(idb.save(storeName, rec, !!rec.id))
                }
              }
            }
            Promise.all(promises).catch(() => {
              alert('Произошла ошибка во время импорта данных')
            }).finally(() => {
              this.$emit('import')
            })
          }).catch(() => {
            alert(1)
          })
        }
      }
    }
  }
}
</script>
